
import { IAcl } from '../IAcl';

export default class UserRegistrationFileEntity implements IAcl {
	public group?: string;

	public isVisitorAcl = false;

	public constructor() {
		this.group = 'User';
	}

	public canRead(): boolean {
		return true;
	}

	public canCreate(): boolean {
		return true;
	}

	public canUpdate(): boolean {
		return true;
	}

	public canDelete(): boolean {
		return true;
	}
}
